import { render, staticRenderFns } from "./IntegrationsMeta.vue?vue&type=template&id=323824d8&scoped=true"
import script from "./IntegrationsMeta.vue?vue&type=script&lang=js"
export * from "./IntegrationsMeta.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsMeta.vue?vue&type=style&index=0&id=323824d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323824d8",
  null
  
)

export default component.exports